export default function StructureProductIcon({ product, children, ...props }) {
  return <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-product-icon={product} {...props}>
    {children}
    {product === 'thermostat' && <>
      <rect x="2.5" y="3.5" width="19" height="17" rx="2" />
      <rect x="5.5" y="6.5" width="13" height="7.5" rx=".75" />
      {[6, 10, 14, 18].map(x => <circle key={x} cx={x} cy="17.25" r=".85" />)}
    </>}
    {product === 'trv' && <>
      <rect x="5.5" y="2" width="13" height="17.5" rx="3" />
      <path d="M5.5 7h13M8.5 2.5v3M12 2.5v3M15.5 2.5v3" />
      <rect x="8.5" y="9.5" width="7" height="6" rx=".8" />
      <path d="M8.5 19.5v2.5h7v-2.5M10.5 20v2m3-2v2" />
    </>}
    {product === 'timer' && <>
      <path data-detail="inlet" d="M9.5 6V2h5v4M9.5 3.75h5" />
      <rect x="2" y="6" width="20" height="13" rx="2.5" />
      <rect data-detail="front-panel" x="4" y="8.5" width="16" height="8.5" rx="1.25" />
      <path data-detail="outlet" d="M4.5 19v3h4v-3" />
      <path data-detail="outlet" d="M15.5 19v3h4v-3" />
    </>}
  </svg>
}
